module.exports = __webpack_public_path__ + "static/assets/3e3cd0753b680a3a269469f2b6fa3e05.png";